import React, { useState, useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { generateSmsCode, VerifySmsCode, registerbyPhoneNumber, generateEmailCode, VerifyEmailCode, registerbyEmail } from "../services/api";
import {
  validateRegisterStep1Form,
  validatePhoneNumberbyCode,
  validatePhoneNumberbyCode2,
} from "../utils/validation";
import Cookies from "js-cookie";
import { useNavigate, useSearchParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import { Phone } from "lucide-react";
import { useTranslation } from 'react-i18next';
import { add } from "lodash";
import tokenManager from "../services/tokenManager";

const Login = ({ initialTab }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(initialTab || "login");
  const [PhoneLoginPathway, setPhoneLoginPathway] = useState(false);
  const [PhoneRegisterPathway, setPhoneRegisterPathway] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [SubmitLoading, setSubmitLoading] = useState(false);
  const [registerData, setRegisterData] = useState({
    lastName: "",
    firstName: "",
    phoneNumber: "",
    email: "",
  });
  //get tagId from parameter
  const tagId = searchParams.get('qr') || '';
  const petlostreport = searchParams.get('petlostreport') || '';
  const [newUser, setNewUser] = useState(false);

  const [forgotData, setForgotData] = useState({ email: "" });
  const [formErrors, setFormErrors] = useState({});
  const [formErrors2, setFormErrors2] = useState("");
  const [message, setMessage] = useState("");
  const [registerStep, setRegisterStep] = useState(1);
  const [PhoneRegisterData, setPhoneRegisterData] = useState({ phoneCode: "+852", phoneNumber2: "" });
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef(new Array(6).fill(null));
  const [countdown, setCountdown] = useState(0); // Set initial countdown value
  const [isDisabled, setIsDisabled] = useState(false);

  const handleChange = (index, value) => {
    setFormErrors2("");
    const newValue = value.replace(/\D/g, "").slice(0, 1);
    const newCode = [...code];
    newCode[index] = newValue;
    setCode(newCode);

    // Move focus to next input if a digit is entered
    if (newValue && index < 5 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }

    // Check if all fields are filled
    if (newCode.every((digit) => digit)) {
      newCode.join("");
      setLoading(true);
      if (PhoneLoginPathway) {
        VerifySmsCode(PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2, newCode.join(""))
          .then((response) => {
            if (response.status === 201 && response.data.token) {
              // Store token and user data using tokenManager
              const token = response.data.token;
              tokenManager.setAuthToken(token);
              
              // Also keep in cookies for backward compatibility (can be removed later)
              Cookies.set("token", token);
              
              // Extract userId from token or response
              const userId = response.data.userId || 
                            response.data.uid || 
                            response.data.u_id ||
                            jwtDecode(token).userId;
              
              const userRole = response.data.role || 
                              response.data.userRole ||
                              jwtDecode(token).userRole;
              
              tokenManager.setUserId(userId?.toString());
              tokenManager.setUserRole(userRole);
              
              // Keep cookies for backward compatibility
              Cookies.set("id", userId?.toString());
              Cookies.set("role", userRole);
              
              if (tagId) {
                navigate(`/pet-management?qr=${tagId}`)
              }
              else if (petlostreport) {
                navigate("/pet_lost_report");
              }
              else {
                navigate("/pet-management"); // Navigate to PetManagementHome.jsx
              }
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            setLoading(false);
            if (error.status === 400) {
              setFormErrors2(t('UnabletoVerifyNumber'));
            }
          });
      }
      else {
        VerifyEmailCode(registerData.email, (newCode.join("")))
          .then((response) => {
            if (response.status === 201) {
              // Store token and user data using tokenManager
              const token = response.data.token;
              tokenManager.setAuthToken(token);
              
              // Also keep in cookies for backward compatibility
              Cookies.set("token", token);
              
              // Extract userId from token or response
              const userId = response.data.userId || 
                            response.data.uid || 
                            response.data.u_id ||
                            jwtDecode(token).userId;
              
              const userRole = response.data.role || 
                              response.data.userRole ||
                              jwtDecode(token).userRole;
              
              tokenManager.setUserId(userId?.toString());
              tokenManager.setUserRole(userRole);
              
              // Keep cookies for backward compatibility
              Cookies.set("id", userId?.toString());
              Cookies.set("role", userRole);
              
              if (tagId) {
                navigate(`/pet-management?qr=${tagId}`)
              }
              else if (petlostreport) {
                navigate("/pet_lost_report?member=true");
              }
              else {
                navigate("/pet-management"); // Navigate to PetManagementHome.jsx
              }
            }
          })
          .catch((error) => {
            setLoading(false);
            if (error.status === 409) {
              setFormErrors2(t('UnabletoVerifyEmail'));
            }
            if (error.status === 410) {
              setFormErrors2(t('VerificationCodeExpired'));
            }
          });
      }
    }
  };

  // Handle key down (e.g., backspace to move to previous input)
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !code[index] && index > 0 && inputRefs.current[index - 1]) {
      const newCode = [...code];
      newCode[index - 1] = "";
      setCode(newCode);
      inputRefs.current[index - 1].focus();
    }
  };

  useEffect(() => {
    if (
      formErrors.email === "請輸入有效的電郵地址" ||
      formErrors.email === "Please enter a valid email"
    ) {
      setFormErrors((prev) => ({
        ...prev,
        email: t('InvalidEmail'),
      }));
    }
    if (
      formErrors.email === "請輸入電郵地址" ||
      formErrors.email === "Please enter email"
    ) {
      setFormErrors((prev) => ({
        ...prev,
        email: t('EnterEmail'),
      }));
    }
    if (
      formErrors.existedUser === "此電郵信箱已註冊" ||
      formErrors.existedUser === "This email address is already registered"
    ) {
      setFormErrors((prev) => ({
        ...prev,
        existedUser: t('ExistedUser'),
      }));
    }
    if (
      formErrors.existedUser2 === "此電話號碼已註冊" ||
      formErrors.existedUser2 === "This phone number is already registered"
    ) {
      setFormErrors((prev) => ({
        ...prev,
        existedUser2: t('ExistedUser2'),
      }));
    }
    if (
      formErrors2 === "聯絡電話只能包含數字" ||
      formErrors2 === "Phone number can only contain numbers"
    ) {
      setFormErrors2(t('OnlyNumbers'));
    }
    if (
      formErrors2 === "請輸入有效的電話號碼" ||
      formErrors2 === "Please enter a valid phone number"
    ) {
      setFormErrors2(t('InvalidPhoneNumber'));
    }
    if (
      formErrors2 === "驗證碼已過期" ||
      formErrors2 === "Verification code has expired"
    ) {
      setFormErrors2(t('VerificationCodeExpired'));
    }
    if (
      formErrors2 === "抱歉，我們無法驗證此程式碼。請確保您輸入了正確的電子郵件地址和驗證碼。" ||
      formErrors2 === "Sorry, we are not able to verify the code. Please make sure you input the right email and code."
    ) {
      setFormErrors2(t('UnabletoVerifyEmail'));
    }
    if (
      formErrors2 === "很抱歉，我們無法驗證此代碼。請確保你輸入正確的電話號碼和驗證碼。" ||
      formErrors2 === "Sorry, we are not able to verify the code. Please make sure you input the right phone number and code."
    ) {
      setFormErrors2(t('UnabletoVerifyNumber'));
    }
    // Do not reset to "" here, only translate if needed
    // If you want to clear errors on language change, do it in a separate effect
  }, [t]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Focus the first input on component mount
  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  // 检查屏幕是否为移动尺寸
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // 初始检查
    checkMobile();

    // 为窗口调整大小添加事件监听器
    window.addEventListener("resize", checkMobile);

    // 清理
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  //scrolled to top and loading screen
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (countdown > 0) {
      setIsDisabled(true);
      const timer = setInterval(() => {
        setCountdown(prevCountdown => prevCountdown - 1);
      }, 1000);

      return () => clearInterval(timer); // Cleanup on unmount
    }
    setIsDisabled(false);
  }, [countdown]);

  useEffect(() => {
    if (PhoneRegisterData !== null && PhoneRegisterData.phoneNumber2) {
      setRegisterData((prev) => ({
        ...prev,
        phoneNumber: PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2,
      }));
    }
  }, [PhoneRegisterData]);

  // 处理登录表单提交
  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   setLoading(true); // Set loading to true when login starts
  //   setFormErrors({});

  //   const validation = validateLoginForm(loginData);
  //   if (!validation.isValid) {
  //     setFormErrors(validation.errors);
  //     return;
  //   }

  //   const maxRetries = 2; // Try up to 2 times
  //   const retryDelay = 10000; // 10 seconds delay

  //   const attemptLogin = async (retriesLeft) => {
  //     try {
  //       console.log("Login attempt:", { loginData, retriesLeft });
  //       const { data } = await login(loginData.username, loginData.password);
  //       console.log("API response:", data);
  //       if (data.success) {
  //         Cookies.set("token", data.token);
  //         const userId = jwtDecode(data.token).userId;
  //         Cookies.set("id", userId.toString());
  //         if (tagId) {
  //           navigate(`/pet-management?qr=${tagId}`)
  //         }
  //         else if (newUser) {
  //           navigate("/pet-management/add");
  //         }
  //         else {
  //           navigate("/pet-management"); // Navigate to PetManagementHome.jsx
  //         }
  //       } else {
  //         setFormErrors({
  //           invalidCredentials: "登录失败，请检查您的输入",
  //         });
  //         setLoading(false); // Stop loading on failure
  //       }
  //     } catch (error) {
  //       console.error("Login error:", {
  //         message: error.message,
  //         response: error.response,
  //         request: error.request,
  //         config: error.config,
  //       });
  //       setLoading(false); // Stop loading on error
  //       if (retriesLeft > 0 && (!error.response || error.code === "ERR_NETWORK")) {
  //         console.log(`Retrying login in ${retryDelay / 1000} seconds...`);
  //         await new Promise((resolve) => setTimeout(resolve, retryDelay));
  //         return attemptLogin(retriesLeft - 1);
  //       }
  //       if (error.response && error.response.data && error.response.data.error === "Invalid user credentials") {
  //         setFormErrors({
  //           invalidCredentials: "電郵{t('or')}密碼錯誤",
  //         });
  //       } else {
  //         setFormErrors({
  //           invalidCredentials: "無法連接到服務器，請稍後再試",
  //         });
  //       }
  //     }
  //   };

  //   await attemptLogin(maxRetries);
  // };

  // Step 1: Email validation and continue
  const handleRegisterEmailContinue = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    const validation = validateRegisterStep1Form(registerData);
    if (!validation.isValid) {
      setSubmitLoading(false);
      if (validation.errors.email === "請輸入有效的電郵地址") {
        setFormErrors({ email: t('InvalidEmail') });
      }
      return;
    }

    try {
      const response = await generateEmailCode(registerData.email);
      if (response.status === 201 && response.data.newUser) {
        setPhoneRegisterPathway(false);
        setSubmitLoading(false);
        setNewUser(true);
        setActiveTab("register-2");
      }
      if (response.status === 201 && !response.data.newUser) {
        setCountdown(59);
        setSubmitLoading(false);
        setActiveTab("register-email-code-tab");
      }
    } catch (error) {
      setSubmitLoading(false);
      setFormErrors("再檢查你個電話號碼");
    }
    // setRegisterStep(2);
  };

  const reGenerateEmailCode = async (e) => {
    e.preventDefault();
    setCountdown(59);
    setIsDisabled(true);

    try {
      await generateEmailCode(registerData.email);
    } catch (error) {
      setFormErrors("再檢查你個電話號碼");
    }
  };

  const reGenerateSmsCode = async (e) => {
    e.preventDefault();
    setCountdown(59);
    setIsDisabled(true);

    try {
      await generateSmsCode(PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2);
    } catch (error) {
      setFormErrors2("再檢查你個電話號碼");
    }
  };

  // Step 2: Complete registration by phoneNumber
  const handleRegisterStep2 = async (e) => {
    e.preventDefault();
    setFormErrors({});
    setSubmitLoading(true);

    const validation2 = validateRegisterStep1Form(registerData);
    if (!validation2.isValid) {
      setSubmitLoading(false);
      if (validation2.errors.email === "請輸入有效的電郵地址") {
        setFormErrors({ email: t('InvalidEmail') });
      }
      if (validation2.errors.email === "請輸入電郵地址") {
        setFormErrors({ email: t('EnterEmail') });
      }
      return;
    }

    setRegisterData((prev) => ({
      ...prev,
      phoneNumber: PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2,
    }));

    try {
      const { data } = await registerbyPhoneNumber(registerData);
      if (data.success) {
        setCountdown(59);
        setSubmitLoading(false);
        setActiveTab("register-sms-code-tab");
        setPhoneLoginPathway(true);
        setIsDisabled(true);

        try {
          await generateSmsCode(PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2);
        } catch (error) {
          setFormErrors("再檢查你個電話號碼");
        }
      }
    } catch (error) {
      setSubmitLoading(false);
      if (error.status === 409) {
        setFormErrors({ existedUser: t('ExistedUser') });
      } else if (error.response?.data?.error) {
        setFormErrors({ api: error.response.data.error });
      } else {
        setFormErrors({ api: t('RegistrationFail') });
      }
    }
  };

  // Step 2: Complete registration by email
  const handleRegisterStep3 = async (e) => {
    e.preventDefault();
    setFormErrors({});
    setFormErrors2("");
    setSubmitLoading(true);
    setRegisterData((prev) => ({
      ...prev,
      phoneNumber: PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2,
    }));

    const validation = validatePhoneNumberbyCode2(PhoneRegisterData, t);
    if (validation !== "") {
      setFormErrors2(validation);
      setSubmitLoading(false);
      return;
    }

    try {
      const { data } = await registerbyEmail(registerData);
      if (data.success) {
        setCountdown(59);
        setSubmitLoading(false);
        setActiveTab("register-email-code-tab");

        try {
          await generateEmailCode(registerData.email);
        } catch (error) {
          setFormErrors("再檢查你個電話號碼");
        }
      }
    } catch (error) {
      setSubmitLoading(false);
      if (error.status === 409) {
        setFormErrors({ existedUser2: t('ExistedUser2') });
      } else if (error.response?.data?.error) {
        setFormErrors({ api: error.response.data.error });
      } else {
        setFormErrors({ api: t('RegistrationFail') });
      }
    }
  };

  //registration by phone number
  const handleRegisterViaPhone = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    const validation = validatePhoneNumberbyCode(PhoneRegisterData);
    if (validation !== "") {
      setFormErrors2(validation);
      setSubmitLoading(false);
      return;
    }

    try {
      const response = await generateSmsCode(PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2);
      console.log(response);
      if (response.status === 201 && !response.data.newUser) {
        setCountdown(59);
        setPhoneLoginPathway(true);
        setSubmitLoading(false);
        setActiveTab("register-sms-code-tab");
      }
      if (response.status === 201 && response.data.newUser) {
        setPhoneRegisterPathway(true);
        setSubmitLoading(false);
        setNewUser(true);
        setActiveTab("register-2");
      }
    } catch (error) {
      setSubmitLoading(false);
      setFormErrors("再檢查你個電話號碼");
    }
  };

  const errorMessageStyle = {
    color: "#F10000",
    fontSize: "14px",
    marginTop: "-15px",
    marginBottom: "10px",
    display: "block",
  };

  const pageStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  };

  const contentStyle = {
    flex: "1 0 auto",
    position: "relative",
    width: "100%",
    paddingTop: "60px",
  };

  const catImageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center center",
    display: "block",
    transition: "transform 0.2s linear",
    willChange: "transform",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 0,
  };

  const desktopFormContainerStyle = {
    position: "absolute",
    top: "50%",
    left: "25%",
    transform: "translate(-50%, -50%)",
    width: "420px",
    backgroundColor: "#FCF8F3A6",
    borderRadius: "10px",
    padding: "30px 40px",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
    zIndex: 1,
  };

  const mobileFormContainerStyle = {
    width: "80%",
    maxWidth: "400px",
    margin: "20px auto",
    padding: "30px 20px",
    backgroundColor: "#FCF8F3CC",
    borderRadius: "10px",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
    zIndex: 1,
  };

  const formTitleStyle = {
    fontSize: isMobile ? "26px" : "var(--font-size-xxl)",
    fontWeight: "bold",
    marginBottom: "5px",
    marginTop: "0",
    textAlign: "left",
  };

  const toggleLinkStyle = {
    fontSize: isMobile ? "var(--font-size-xs)" : "var(--font-size-base)",
    color: "var(--color-text)",
    marginBottom: "20px",
    display: "block",
    textAlign: "left",
  };

  const toggleLinkSpanStyle = {
    color: "var(--color-primary)",
    cursor: "pointer",
  };

  const labelStyle = {
    display: "block",
    fontSize: isMobile ? "13px" : "var(--font-size-lg)",
    marginBottom: "8px",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    marginBottom: "8px",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
    boxSizing: "border-box",
    fontSize: isMobile ? "12px" : "16px",
    fontFamily: "Helvetica",
    backgroundColor: "white",
  };

  const VerificationCodeContainer = {
    display: "flex",
    gap: "8px",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "20px",
  };

  const VerificationCodeInput = {
    width: isMobile ? "40px" : "50px",
    height: isMobile ? "40px" : "50px",
    border: "2px solid #ccc",
    borderRadius: "5px",
    textAlign: "center",
    fontSize: "24px",
    fontWeight: "bold",
  };

  const selectStyle = {
    width: "90px",
    padding: "10px 12px",
    marginBottom: "8px",
    border: "1px solid white",
    borderRight: '10px solid white',
    borderRadius: "10px",
    boxSizing: "border-box",
    fontSize: isMobile ? "12px" : "16px",
    fontFamily: "Helvetica",
    backgroundColor: "white",
  };

  const passwordInputContainerStyle = {
    position: "relative",
    marginBottom: "20px",
  };

  const passwordVisibilityStyle = {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "#888",
  };

  const buttonStyle = {
    width: "100%",
    padding: "12px",
    backgroundColor: isMobile ? "#FFC107" : "var(--color-button-primary)",
    color: "var(--color-black)",
    border: "none",
    borderRadius: "3px",
    fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
    fontWeight: "bold",
    cursor: "pointer",
    marginTop: "10px",
    ...(isDisabled && {
      backgroundColor: "#ccc", // Change background for disabled
      cursor: "not-allowed", // Change cursor for disabled
      opacity: 0.6, // Reduce opacity for disabled
    }),
  };

  const checkboxContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
    flexWrap: isMobile ? "wrap" : "nowrap",
  };

  const checkboxLabelStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
    color: "var(--color-text)",
    cursor: "pointer",
    marginBottom: isMobile ? "10px" : "0",
    width: "auto",
  };

  const termsStyle = {
    fontSize: isMobile ? "12px" : "13px",
    color: "var(--color-text)",
    marginTop: "20px",
    textAlign: "center",
  };

  const termsLinkStyle = {
    color: "var(--color-primary)",
    cursor: "pointer",
  };

  const backButtonStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: isMobile ? "26px" : "var(--font-size-xxl)",
    fontWeight: "bold",
    marginBottom: "20px",
    cursor: "pointer",
  };

  const mobileBgStyle = {
    backgroundImage: 'url("/atlas/cat.png")',
    backgroundSize: "cover",
    backgroundPosition: "70% center",
    minHeight: "100vh",
    paddingTop: "40px",
    paddingBottom: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const mobileLogoStyle = {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "20px",
    textAlign: "center",
  };

  const ArrowLeft = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: "8px" }}
    >
      <path
        d="M15 19L8 12L15 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const EyeIcon = ({ visible }) =>
    visible ? (
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="12"
          cy="12"
          r="3"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ) : (
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="12"
          cy="12"
          r="3"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 3L21 21"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );

  const renderRegisterStep1 = () => (
    <div>
      <h2 style={{ fontWeight: 700, fontSize: 32, marginBottom: 8 }}>
        {t('Welcometitle')}
      </h2>
      {/* <div style={{ fontSize: 16, marginBottom: 24 }}>
        已經有帳號？{" "}
        <span
          style={{ color: "#1a73e8", cursor: "pointer" }}
          onClick={() => setActiveTab("login")}
        >
          登入
        </span>
      </div> */}
      <form onSubmit={handleRegisterEmailContinue}>
        <label style={labelStyle}>{t('email')} </label>
        <input
          type="email"
          placeholder="example@mail.com"
          value={registerData.email}
          onChange={(e) =>
            setRegisterData({
              ...registerData, email: e.target.value,
              ...(registerData.email && setFormErrors({})),
            })
          }
          style={inputStyle}
          required
        />
        {formErrors.email && (
          <div style={{ color: "#f10000", fontSize: 14, marginBottom: 8 }}>
            {formErrors.email}
          </div>
        )}

        <Button
          variant="contained"
          type="submit"
          sx={{
            width: "100%",
            padding: "12px",
            backgroundColor: isMobile ? "#FFC107" : "var(--color-button-primary)",
            color: "var(--color-black)",
            border: "none",
            borderRadius: "3px",
            fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
            fontWeight: "bold",
            cursor: "pointer",
            marginTop: "10px",
            boxShadow: "none",
            "&:hover": { background: "#FFB60C" },
            "&:disabled": { background: "rgba(255, 182, 12, 0.5)" },
            cursor: SubmitLoading ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            textTransform: 'none',
          }}
          disabled={SubmitLoading}
        >
          {t('Continue')}
          {SubmitLoading && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <CircularProgress size={20} color="inherit" />
            </span>
          )}
        </Button>
      </form>
      <div style={{ display: "flex", alignItems: "center", margin: "24px 0" }}>
        <div style={{ flex: 1, height: 1, background: "#e0e0e0" }}></div>
        {t('or')}
        <div style={{ flex: 1, height: 1, background: "#e0e0e0" }}></div>
      </div>
      <Button
        variant="contained"
        sx={{
          width: "100%",
          padding: "12px",
          background: "#fff",
          color: "var(--color-black)",
          border: "none",
          borderRadius: "3px",
          fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          boxShadow: "none",
          textTransform: 'none',
          "&:hover": { background: "#d4d3d3ff" },
        }}
        onClick={() => setActiveTab("register-via-phone")}
      >
        <img
          src="/icons/phone.svg"
          alt="Phone"
          style={{ width: 22, height: 22, position: 'absolute' }}
        />{" "}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
          {t('LoginWithPhoneNo')}
        </div>
      </Button>
    </div>
  );

  // Registration Step 2 UI
  const renderRegisterStep2 = () => (
    <div>
      <h2 style={{ fontWeight: 700, fontSize: 32, marginBottom: 8 }}>
        {t('CompleteRegistration')}
      </h2>
      <form onSubmit={PhoneRegisterPathway ? handleRegisterStep2 : handleRegisterStep3}>
        {formErrors.existedUser && (
          <div style={{ color: "#f10000", fontSize: 14, marginBottom: 8 }}>
            {formErrors.existedUser}
          </div>
        )}
        {formErrors.existedUser2 && (
          <div style={{ color: "#f10000", fontSize: 14, marginBottom: 8 }}>
            {formErrors.existedUser2}
          </div>
        )}
        <label
          style={{
            fontWeight: 500,
            fontSize: 16,
            marginBottom: 8,
            display: "block",
          }}
        >
          {t('LastName')}
        </label>
        <input
          type="text"
          placeholder={t('LastName')}
          value={registerData.lastName}
          onChange={(e) =>
            setRegisterData({ ...registerData, lastName: e.target.value })
          }
          style={inputStyle}
          required
        />
        <label
          style={{
            fontWeight: 500,
            fontSize: 16,
            marginBottom: 8,
            display: "block",
          }}
        >
          {t('FirstName')}
        </label>
        <input
          type="text"
          placeholder={t('FirstName')}
          value={registerData.firstName}
          onChange={(e) =>
            setRegisterData({ ...registerData, firstName: e.target.value })
          }
          style={inputStyle}
          required
        />
        <label style={{
          fontWeight: 500,
          fontSize: 16,
          marginBottom: 8,
          display: "block",
        }}>{t('phoneNumber')}</label>
        <div style={{ display: 'flex', gap: '10px', marginBottom: 10 }}>
          <select
            style={selectStyle}
            value={PhoneRegisterData.phoneCode}
            onChange={(e) =>
              setPhoneRegisterData({ ...PhoneRegisterData, phoneCode: e.target.value })
            }
            renderValue={(value) => value}
            required
            disabled={PhoneRegisterPathway}
          >

            <option value="+852">+852</option>
            <option value="+853">+853</option>
            <option value="+86">+86</option>
            <option value="+865">+865</option>
            <option value="+81">+81</option>
            <option value="+880">+880</option>
          </select>
          <input
            type="tel"
            placeholder={t('phoneNumber')}
            style={inputStyle}
            value={PhoneRegisterData.phoneNumber2}
            required
            onChange={(e) => {
              setPhoneRegisterData({ ...PhoneRegisterData, phoneNumber2: e.target.value });
              if (e.target.value) setFormErrors2("");
            }}
            disabled={PhoneRegisterPathway}   
          />
        </div>
        {formErrors2 && (<span style={errorMessageStyle}>{formErrors2}</span>)}
        <label
          style={{
            fontWeight: 500,
            fontSize: 16,
            marginBottom: 8,
            display: "block",
          }}
        >
          {t('email')}
        </label>
        <input
          type="email"
          placeholder="example@mail.com"
          value={registerData.email}
          onChange={(e) =>
            setRegisterData({ ...registerData, email: e.target.value })
          }
          style={inputStyle}
          required
          disabled={!PhoneRegisterPathway}
        />
        {formErrors.email && (
          <div style={{ color: "#f10000", fontSize: 14, marginBottom: 8 }}>
            {formErrors.email}
          </div>
        )}
        <label
          style={{
            fontWeight: 500,
            fontSize: 12,
            paddingBottom: "10px",
            display: "block",
          }}
        >
          {t('RegistrationInfo')} <a className="text-blue-600" href="/privacy?section=second-section" target="_blank">{t('TermsOfService')}</a> {t('And')} <a className="text-blue-600" href="/privacy" target="_blank">{t('PrivacyPolicy')}</a>
        </label>

        <Button
          variant="contained"
          type="submit"
          sx={{
            width: "100%",
            padding: "12px",
            backgroundColor: isMobile ? "#FFC107" : "var(--color-button-primary)",
            color: "var(--color-black)",
            border: "none",
            borderRadius: "3px",
            fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
            fontWeight: "bold",
            cursor: "pointer",
            marginTop: "10px",
            boxShadow: "none",
            "&:hover": { background: "#FFB60C" },
            "&:disabled": { background: "rgba(255, 182, 12, 0.5)" },
            cursor: SubmitLoading ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            textTransform: 'none',
          }}
          disabled={SubmitLoading}
        >
          {t('Continue')}
          {SubmitLoading && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <CircularProgress size={20} color="inherit" />
            </span>
          )}
        </Button>
      </form>
    </div>
  );

  const renderRegisterForm = () =>
    registerStep === 1 ? renderRegisterStep1() : renderRegisterStep2();

  const renderSmsCodeTab = () => (
    <>
      <h2 style={{ fontWeight: 700, fontSize: 32, marginBottom: 8 }}>
        {t('confirmPhoneNumber')}
      </h2>

      <div style={{ fontSize: 14, marginBottom: 10 }}>
        {t('VerficationSentSMS')} {PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2}：
      </div>
      <div style={VerificationCodeContainer}>
        {code.map((digit, index) => (
          <input
            key={index}
            type="tel"
            ref={(el) => (inputRefs.current[index] = el)}
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            maxLength="1"
            style={VerificationCodeInput}
            autoComplete="off"
          />
        ))}
      </div>
      {formErrors2 && (<span style={errorMessageStyle}>{formErrors2}</span>)}
      <Button
        variant="contained"
        disabled={isDisabled}
        onClick={reGenerateSmsCode}
        sx={{
          width: "100%",
          padding: "12px",
          backgroundColor: isMobile ? "#FFC107" : "var(--color-button-primary)",
          color: "var(--color-black)",
          border: "none",
          borderRadius: "3px",
          fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
          fontWeight: "bold",
          cursor: "pointer",
          marginTop: "10px",
          boxShadow: "none",
          textTransform: 'none',
          "&:hover": { background: "#FFB60C" },
        }}
      >
        {t('Resend')} {countdown > 0 ? " 00:" + (countdown < 10 ? "0" : "") + countdown : ""}
      </Button>
    </>
  );

  const renderEmailCodeTab = () => (
    <>
      <h2 style={{ fontWeight: 700, fontSize: 32, marginBottom: 8 }}>
        {t('confirmEmail')}
      </h2>

      <div style={{ fontSize: 14, marginBottom: 10 }}>
        {t('VerficationSentEmail')} {registerData.email}：
      </div>
      <div style={VerificationCodeContainer}>
        {code.map((digit, index) => (
          <input
            key={index}
            type="tel"
            ref={(el) => (inputRefs.current[index] = el)}
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            maxLength="1"
            style={VerificationCodeInput}
            autoComplete="off"
          />
        ))}
      </div>
      {formErrors2 && (<span style={errorMessageStyle}>{formErrors2}</span>)}
      <Button
        variant="contained"
        disabled={isDisabled}
        onClick={reGenerateEmailCode}
        sx={{
          width: "100%",
          padding: "12px",
          backgroundColor: isMobile ? "#FFC107" : "var(--color-button-primary)",
          color: "var(--color-black)",
          border: "none",
          borderRadius: "3px",
          fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
          fontWeight: "bold",
          cursor: "pointer",
          marginTop: "10px",
          boxShadow: "none",
          textTransform: 'none',
          "&:hover": { background: "#FFB60C" },
        }}
      >
        {t('Resend')} {countdown > 0 ? "00:" + (countdown < 10 ? "0" : "") + countdown : ""}
      </Button>
    </>
  );

  const renderRegisterViaPhone = () => (
    <>
      <h2 style={{ fontWeight: 700, fontSize: 32, marginBottom: 8 }}>
        {t('Welcometitle')}
      </h2>
      {/* <div style={{ fontSize: 16, marginBottom: 24 }}>
        已經有帳號？{" "}
        <span
          style={{ color: "#1a73e8", cursor: "pointer" }}
          onClick={() => setActiveTab("login")}
        >
          登入
        </span>
      </div> */}

      {message && <span style={errorMessageStyle}>{message}</span>}

      <form onSubmit={handleRegisterViaPhone}>
        <label style={labelStyle}>{t('phoneNumber')}</label>
        <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
          <select
            style={selectStyle}
            value={PhoneRegisterData.phoneCode}
            onChange={(e) =>
              setPhoneRegisterData({ ...PhoneRegisterData, phoneCode: e.target.value })
            }
            renderValue={(value) => value}
            required
          >

            <option value="+852">+852</option>
            <option value="+853">+853</option>
            <option value="+86">+86</option>
            <option value="+865">+865</option>
            <option value="+81">+81</option>
            <option value="+880">+880</option>
          </select>
          <input
            type="tel"
            placeholder={t('phoneNumber')}
            style={inputStyle}
            value={PhoneRegisterData.phoneNumber2}
            onChange={(e) =>
              setPhoneRegisterData({
                ...PhoneRegisterData, phoneNumber2: e.target.value,
                ...(PhoneRegisterData.phoneNumber2 && setFormErrors2("")),
              })
            }
            required
          />
        </div>

        {formErrors2 && (
          <span style={errorMessageStyle}>{formErrors2}</span>
        )}

        <Button
          variant="contained"
          type="submit"
          sx={{
            width: "100%",
            padding: "12px",
            backgroundColor: isMobile ? "#FFC107" : "var(--color-button-primary)",
            color: "var(--color-black)",
            border: "none",
            borderRadius: "3px",
            fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
            fontWeight: "bold",
            cursor: "pointer",
            marginTop: "10px",
            boxShadow: "none",
            "&:hover": { background: "#FFB60C" },
            "&:disabled": { background: "rgba(255, 182, 12, 0.5)" },
            cursor: SubmitLoading ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            textTransform: 'none',
          }}
          disabled={SubmitLoading}
        >
          {t('Continue')}
          {SubmitLoading && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <CircularProgress size={20} color="inherit" />
            </span>
          )}
        </Button>
      </form>
      <div style={{ display: "flex", alignItems: "center", margin: "24px 0" }}>
        <div style={{ flex: 1, height: 1, background: "#e0e0e0" }}></div>
        {t('or')}
        <div style={{ flex: 1, height: 1, background: "#e0e0e0" }}></div>
      </div>
      <Button
        variant="contained"
        sx={{
          width: "100%",
          padding: "12px",
          background: "#fff",
          color: "var(--color-black)",
          border: "none",
          borderRadius: "3px",
          fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          boxShadow: "none",
          textTransform: 'none',
          "&:hover": { background: "#d4d3d3ff" },
        }}
        onClick={() => setActiveTab("register")}
      >
        <img
          src="/icons/email.png"
          alt="email"
          style={{ width: 22, height: 22, position: 'absolute' }}
        />{" "}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
          {t('LoginWithEmail')}
        </div>
      </Button>
    </>
  );

  const renderActiveForm = () => {
    switch (activeTab) {
      case "register":
        return renderRegisterForm();
      case "register-2":
        return renderRegisterStep2();
      case "register-via-phone":
        return renderRegisterViaPhone();
      case "register-sms-code-tab":
        return renderSmsCodeTab();
      case "register-email-code-tab":
        return renderEmailCodeTab();
      default:
        return renderRegisterForm();
      // return renderLoginForm();
    }
  };

  return (
    <div style={pageStyle}>
      <Navbar />
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh", // Full viewport height for centering
          }}
        >
          <Typography variant="h6" color="text.secondary">
            <img
              src="https://petpetclub.s3.ap-southeast-1.amazonaws.com/user-uploads/pets/68cb893a0feda12f2dbcc02b/68d4c8ce22baedfbe8b852dd.gif"
              alt="Loading"
              style={{
                width: "150px",
                height: "auto",
                mixBlendMode: "multiply",
              }}
            />
            <div
              style={{
                fontWeight: "500px",
                fontSize: "15px",
                textAlign: "center",
                fontFamily: "Lucida Console",

              }}>
              {t('Loading')}
            </div>
          </Typography>
        </Box>
      ) : !isMobile ? (
        <div style={contentStyle}>
          <div style={{ position: "relative", height: "100vh" }}>
            <img
              src="/atlas/cat.png"
              alt="登录注册猫"
              style={catImageStyle}
              loading="eager"
            />
            <div style={desktopFormContainerStyle}>{renderActiveForm()}</div>
          </div>
        </div>
      ) : (
        <div style={contentStyle}>
          <div style={mobileBgStyle}>
            <div style={mobileLogoStyle}>PTag</div>
            <div style={mobileFormContainerStyle}>{renderActiveForm()}</div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Login;
